var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.43 64.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00a193;}.cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.36,22.55,46.1,20.28A7.58,7.58,0,1,0,36.26,8.75l-4.32,3.82-.86-5.73A7.58,7.58,0,1,0,16.13,9.37l-5.9-2.15A5.61,5.61,0,0,0,3,10.57l-2.55,7A1.87,1.87,0,0,0,1.6,20L30.8,30.61H2.61A1.87,1.87,0,0,0,.74,32.48V58.64a5.61,5.61,0,0,0,5.6,5.61H43.71a5.62,5.62,0,0,0,5.61-5.61V37.35l1.44.53a1.87,1.87,0,0,0,2.4-1.12l2.55-7A5.61,5.61,0,0,0,52.36,22.55Zm-13.63-11A3.84,3.84,0,1,1,40,18l-6.08-2.21ZM21.31,4.86a3.84,3.84,0,0,1,6.07,2.53l1,6.42L22.27,11.6A3.87,3.87,0,0,1,21.31,4.86Zm.88,18.64L4.64,17.11l1.91-5.26A1.88,1.88,0,0,1,9,10.73l15.8,5.75Zm7,2.56-3.51-1.28,2.55-7L31.77,19Zm-9.8,34.45H6.34a1.87,1.87,0,0,1-1.86-1.87V34.35H19.42Zm7.48,0H23.16V34.35H26.9Zm18.68-1.87a1.87,1.87,0,0,1-1.87,1.87H30.63V34.35H41.07L45.58,36ZM52.2,28.46l-1.91,5.27L32.73,27.34l2.55-7,15.81,5.75A1.86,1.86,0,0,1,52.2,28.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.58,36V58.64a1.87,1.87,0,0,1-1.87,1.87H30.63V34.35H41.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.42,34.35V60.51H6.34a1.87,1.87,0,0,1-1.86-1.87V34.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg54);
export default __webpack_public_path__ + "static/media/54.3a028bbdee07fe5b6e07f4febdff19ab.svg";
export { ForwardRef as ReactComponent };